<template>
  <div
    class="tool-info"
    id="tool-info"
    v-bind:class="{ marathon: pointStore.selectedPoint.IsMarathon, open: !!pointStore.selectedPoint }"
  >
    <div
      class="close"
      @click="togglePoint(pointStore.selectedPoint)"
    ></div>
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-7 col-lg-8">
          <div class="flex-div">
            <div class="inner-flex-div">
              <h2><span
                  class="icon-Marathon"
                  v-if="pointStore.selectedPoint.IsMarathon"
                ></span>{{ pointStore.selectedPoint.Name }}</h2>
              <div class="row-image">
                <div class="point-image">
                  <picture>
                    <source
                      :srcset="pointStore.selectedPoint.MobileImage"
                      media="(max-width: 991px)"
                    />
                    <img
                      class="tool-image"
                      :src="pointStore.selectedPoint.Image"
                      :alt="pointStore.selectedPoint.ImageAlt"
                      :title="pointStore.selectedPoint.ImageTitle"
                    />
                  </picture>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 tool-body">
                <div
                  class="main-body"
                  v-html="pointStore.selectedPoint.MainBody"
                ></div>
                <div class="row">
                  <span class="articlenr">{{translatedArtNr}} &nbsp;</span>
                  <span>{{pointStore.selectedPoint.ArticleNr}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row-info">
            <div class="properties">
              <h3>{{ pointStore.selectedPoint.Properties }}</h3>
                <div class="block iconblockmodel quarter col-xs-3">
                  <div class="row icon-block">
                      <div class="no-link">
                        <span :class="[activeConfiguratorDepthIcon]"></span>
                        <p>{{ pointStore.selectedPoint.Range }}</p>
                      </div>
                  </div>
                </div>
                <div class="block iconblockmodel quarter col-xs-3">
                  <div class="row icon-block">
                    <div class="col-md-12">
                      <div class="no-link">
                        <span :class="[activeConfiguratorSizeIcon]"></span>
                        <p>{{ pointStore.selectedPoint.Width }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="block iconblockmodel quarter col-xs-3"
                  v-for="category in pointStore.selectedPoint.Categories"
                  v-bind:key="category.Id"
                >
                  <div class="row icon-block">
                    <div class="col-md-12">
                      <div class="no-link">
                        <span :class="category.IconClass"></span>
                        <p>{{ category.Name }}</p>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div
              class="fits-with"
              v-if="pointStore.selectedPoint.Shins && pointStore.selectedPoint.Shins.length > 0"
            >
              <h3 class="fits-with__heading">{{ pointStore.selectedPoint.Name }} {{ pointStore.selectedPoint.ShinText }}</h3>
              <div class="row">
                <div
                  class="shin"
                  v-for="shin in pointStore.selectedPoint.Shins"
                  v-bind:key="shin.Id"
                >
                  <img
                    :src="shin.Image"
                    :alt="shin.ImageAlt"
                    :title="shin.ImageTitle"
                  />
                    <div class="shin__text">
                  <p class="shin__name">{{ shin.Name }}</p>
                  <p class="shin__shintext">{{ shin.ImageText }}</p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-5 col-lg-4">
          <picture>
            <source
              :srcset="pointStore.selectedPoint.CrossSectionMobileImage"
              media="(max-width: 991px)"
            />
            <img
              class="soil-cutthrough"
              :src="pointStore.selectedPoint.CrossSectionImage"
              :alt="pointStore.selectedPoint.CrossSectionImageAlt"
              :title="pointStore.selectedPoint.CrossSectionImageTitle"
            />
          </picture>
        </div>
      </div>
      <div class="row tool-products">
        <h3>
          {{ pointStore.selectedPoint.Name }} {{ pointStore.selectedPoint.ProductText }}
        </h3>
        <div
          class="block contentlinkblockmodel third"
          v-for="product in pointStore.selectedPoint.Products"
          v-bind:key="product.Id"
        >
          <a
            v-bind:href="product.Link"
            class="contentlink-block-link"
            target="_self"
          >
            <div class="content-block">
              <img
                :src="product.Image"
                alt=" "
              />
              <div class="content">
                <div class="heading">
                  <h4>{{ product.Name }}</h4>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { usePointStore } from '../store/store';
import { getActiveConfiguratorDepthIconClass, getActiveConfiguratorSizeIconClass } from '../helpers/configuratorHelper';
import { ref } from "vue";
const pointStore = usePointStore();

const activeConfiguratorDepthIcon = getActiveConfiguratorDepthIconClass();
const activeConfiguratorSizeIcon = getActiveConfiguratorSizeIconClass();
const translatedArtNr = ref(articleNr); // From Razor view script tag

const emit = defineEmits([
  'togglePoint'
]);

function togglePoint(point) {
  emit('togglePoint', point);
}

window.onclick = function(event) {
  var outside = document.getElementById('js-content');
  
  if (event.target == outside) {
    togglePoint(pointStore.selectedPoint);
  }
}
</script>